const JWT_STORAGE_KEY = 'JWT_TOKEN'

const INVALID_TOKEN_LITERALS = new Set(['null', 'undefined'])

/**
 * Retorna Authorization Bearer somente com JWT válido; null = omitir o header.
 */
export const getAuthHeader = (): string | null => {
    try {
        const token = sessionStorage.getItem(JWT_STORAGE_KEY)
        if (token == null) {
            return null
        }
        const trimmed = String(token).trim()
        if (!trimmed) {
            return null
        }
        if (INVALID_TOKEN_LITERALS.has(trimmed.toLowerCase())) {
            return null
        }
        return `Bearer ${trimmed}`
    } catch {
        return null
    }
}

/**
 * Aplica ou remove Authorization em um objeto de headers Axios/plain.
 */
export const applyAuthorizationHeader = (headers: {
    Authorization?: string
    authorization?: string
    delete?: (name: string) => void
    set?: (name: string, value: string) => void
}): void => {
    const auth = getAuthHeader()
    if (auth) {
        if (typeof headers.set === 'function') {
            headers.set('Authorization', auth)
        } else {
            headers.Authorization = auth
        }
        return
    }
    if (typeof headers.delete === 'function') {
        headers.delete('Authorization')
    } else {
        delete headers.Authorization
        delete headers.authorization
    }
}
